export default "__VITE_ASSET__yqxSvOIe__"